import React from 'react'
import BlueImage from '../images/blue-bg.png'
import { useThemeMode } from '../../../../_metronic/partials'
import { useIntl } from 'react-intl'

const MiniStartupCard = () => {

    const { mode } = useThemeMode()
    const { formatMessage } = useIntl()

    return (
        <>
            <div className='bg-white rounded p-2 w-md-50 w-100 d-md-flex align-items-center gap-4 mb-2 mb-md-auto'>
                <img className='rounded-3 w-md-auto w-100 mb-2 mb-md-0' src={BlueImage} height={160} width={200} alt="" />
                <div className='w-100'>
                    <div className='d-flex justify-content-between w-100'>
                        <div className={`px-4 py-2 category` + (mode === `dark` ? `-dark` : ``)}>
                            Technology
                        </div>
                        <button className='bg-light rounded border-0 text-muted px-4'>Edit</button>
                    </div>
                    <div className='py-2 '>
                        <h1 className='font-size-16'>Get 50% off on gold plan for 3 Months</h1>
                        <p className='font-size-12'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has bee...</p>
                        <div className='d-md-flex w-100 w-md-auto justify-content-end'><button className='btn btn-primary w-100 w-md-auto'>{formatMessage({ id: 'Know More' })}</button></div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MiniStartupCard
